<template>
  <div class="bg-FF p-20">
    <div v-if="messages && messages.length>0" class="income-form-tit">

      <el-alert
          :closable="false"
          class="customAlert"
          type="warning"
      >
        <template slot="title">
          <div class="iconSize">【操作提示】</div>
          <div class="iconSize">一、先填以下关键信息：</div>
          <div v-for="(message, index) in messages" :key="index" class="iconSize">{{ index + 1 }}.{{ message }}</div>
          <div class="iconSize">二、确认无误后，再选择「审批/抄送人员」；</div>
          <div class="iconSize">特别注意：若先选人员再修改上述信息，可能导致流程分支变化，需重新调整人员选择！</div>
        </template>
      </el-alert>
    </div>
    <div v-for="(activity, index) in cc" :key="index">
      <van-row>
        <van-col span="2">
          <div class="w-46 h-46 l-h-46 bg-FFDB43 border-50 font-24 cor-33 font-weight-600 text-center">{{
              index + 1
            }}
          </div>
          <div class="line"
               :style="(index + 1) != cc.length ? 'background-color: #FFE36D;' : 'background-color: #FFFFFF;'"></div>
        </van-col>
        <van-col span="22">
          <div class="font-30 cor-33 font-weight-600">{{ activity.title }}</div>
          <div class="m-t-10 flex" style="justify-content: space-between">
            <div v-if="activity.users == null || activity.users.length == 0" class="font-30 cor-CC">
              {{ activity.desc || '' }}
            </div>
            <div v-else @click="auditMore(activity)" class="flex">
              <img class="w-24 h-24" :src="`${image_base_url}/ren.png`"/>
              <div class="font-28 cor-FFDB43" v-if="(activity.users[0].name) && (activity.users[0].name.length)">
                {{
                  activity.users[0].name.length > 4 ? activity.users[0].name.substring(0, 2) + '..' : activity.users[0].name
                }}
              </div>
              <div v-if="activity.users.length > 1" class="flex m-l-20">
                <img class="w-40 h-40" :src="`${image_base_url}/diandiandian.png`"/>
                <div class="font-28 cor-FFDB43">更多</div>
              </div>
            </div>
            <div v-if="activity.isEdit && (activity.multiple || 0 === activity.users.length)"
                 @click="addUser(activity)">
              <img class="w-40 h-40" :src="`${image_base_url}/tianjia.png`"/>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
    <!--     流程选择人弹出层 -->
    <van-popup v-model="auditPopup" position="bottom" @close="popupClose">
      <van-nav-bar :title="`已选择（${nowNodeAuditUser.length}人）`" left-text="取消" right-text="确定"
                   @click-left="auditPopup = false" @click-right="auditPopup = false"/>
      <div class="p-20">
        <!-- 使用vuedraggable实现拖拽排序 -->
        <draggable
            v-model="nowNodeAuditUser"
            :disabled="!selectedNode.isEdit"
            @end="onDragEnd"
            handle=".drag-handle"
            ghost-class="ghost"
            chosen-class="chosen"
            animation="200"
        >
          <transition-group type="transition" name="flip-list">
            <van-row
                type="flex"
                align="center"
                v-for="(audit, index) in nowNodeAuditUser"
                :key="audit.id"
                class="p-10 draggable-item"
            >
              <van-col :span="14">
                <div class="drag-handle m-r-10 flex"
                     style="cursor: grab;">
                  <!-- 拖拽手柄 -->
                  <div class="avatar">{{ audit.name.substring(0, 1) }}</div>
                  <div class="font-30 m-l-14">{{ audit.name }}</div>
                </div>
              </van-col>
              <van-col :span="10" class="flex justify-end" style="justify-content: flex-end;">
                <div class="flex">
                  <!-- 移除按钮 -->
                  <van-button size="small" round color="#c75450" @click="delAudit(audit)" text="移除"></van-button>
                </div>
              </van-col>
            </van-row>
          </transition-group>
        </draggable>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getProject} from '@/api/project/project'
import cache from "@/plugins/cache";
import draggable from 'vuedraggable'; // 引入vuedraggable

export default {
  components: {
    draggable  // 注册组件
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    processData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    auditList: {
      type: Object,
      default: () => {
        return {}
      },
    },
    formItemMap: {
      type: Map,
      default: () => {
        return {}
      },
    }
  },
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    }),
  },
  watch: {
    processData: {
      handler(nv) {
        this.form = nv;
        if (this.form.nodeCacheUsers) {
          this.nodeCacheUsers = this.form.nodeCacheUsers
        }
        this.startProcess();
      },
      immediate: true,
    },
    formData: {
      async handler(nv) {
        // 根据项目选择，自动获取项目负责人
        if (nv.ssxm) {

        }
        this.startProcess();
      },
      deep: true
    },
    auditList: {
      handler() {
        this.buildCc();
      },
      immediate: true,
      deep: true
    },
    formItemMap: {
      handler() {
        console.log(this.formItemMap, 'formItemMapformItemMapformItemMap')
        this.joinCondition();
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      forceRefresh: false,
      messages: [],
      form: {},
      process: '',
      cc: [],
      selfSelect: false,
      processUsers: {},
      allProcessUsers: {},
      conditionFormItem: new Set(),
      activities: [],
      processFormInfo: {},
      loginUser: {
        "id": JSON.parse(cache.session.get('userInfo')).userId,
        "name": JSON.parse(cache.session.get('userInfo')).nickName,
        "type": "user",
        "sex": "0",
        "selected": false
      },
      selectedNode: {},
      auditPopup: false,

      // 当前操作节点的审核人
      nowNodeAuditUser: [],
      // 项目经理
      projectLeader: {}
    }
  },
  async mounted() {


  },
  methods: {
    joinCondition() {
      this.messages = []
      if (this.conditionFormItem && this.conditionFormItem.size > 0) {
        console.log(this.conditionFormItem, 'conditionFormItemconditionFormItem')
        this.conditionFormItem.forEach((formItemId) => {

          let formItem = this.formItemMap.get(formItemId)
          if (formItem) {
            this.messages.push(formItem.title)
          }
        })
        if (this.messages.length > 0) {
          //message = "输入或调整如下表单内容：<br><strong>"+message+"</strong><br>可能会切换流程分支，请先录入表单内容，录入完毕再调整审批人员和抄送人员，以避免发生错选、漏选的情况！";
          /*this.$message({
            type: 'warning',
            iconClass:'',
            dangerouslyUseHTMLString: true,
            duration:10000,
            showClose:true,
            message: message
          });*/
          //this.message = message
          return true
        }
      }
      return false
    },
    async setProjectLeader(formData) {
      let ssxms = formData.ssxm.split(',');
      if (ssxms[0] != this.projectLeader.projectId) {
        const rsp = await getProject(ssxms[0])
        this.projectLeader = rsp.data
      }
      this.startProcess();
    },
    // 后台需要的是这次改动的节点用户数据，所以这个函数需要过滤所有数据，返回新添加的节点人员
    getProcessUsers() {
      let processUsers = {}
      this.cc.forEach(item => {
        if (item.isEdit) { // 必须是可编辑的节点
          // 过滤item.users，取!user.selected，构建新的用户列表
          // processUsers[item.id] = item.users.filter(user => !user.selected);
          processUsers[item.id] = item.users;
        }
      })
      // 删除空数组
      for (const processUsersKey in processUsers) {
        if (processUsers[processUsersKey].length === 0) {
          delete processUsers[processUsersKey]
        }
      }
      return processUsers
    },

    /**
     * 判断所有流程节点的审批人信息，看是不是必填项
     * @return [Promise]
     */
    getAllRequiredPromiseList() {
      console.log(this.cc, 'cccc')
      // 构建一个promise对象数组
      let promiseList = [];
      this.cc.forEach(item => {
        if (item.required) {
          promiseList.push(this.isUsers(item))
        }
      })
      console.log(promiseList, 'promiseListpromiseListpromiseList')
      return promiseList
    },
    /**
     * 判断是否有审批人
     * @param item
     * @return <Promise>
     */
    isUsers(item) {
      return new Promise((resolve, reject) => {
        if (!item.users || item.users.length === 0) {
          reject(item)
        } else {
          resolve(item)
        }
      })
    },

    /**
     *  构建名称
     *  2个子直接显示，超出2个显示最后2个
     */
    buildName(name) {
      if (name == null || name == undefined || name == '') {
        return "";
      } else {
        if (name.length > 2) {
          return name.substring(name.length - 2, name.length);
        } else {
          return name;
        }
      }
    },
    /**
     *  移除人员
     */
    delAudit(audit) {
      this.nowNodeAuditUser = this.nowNodeAuditUser.filter(item => item.id !== audit.id);
      let node = this.cc.find(item => item.id === this.selectedNode.id);
      if (node) {
        node.users = node.users.filter(item => item.id !== audit.id);
      }
      if (this.nowNodeAuditUser.length === 0) {
        this.auditPopup = false
      }
      this.$emit('delUser', this.selectedNode, audit)
    },
    /**
     *  拖拽结束事件
     */
    onDragEnd() {
      // 拖拽结束后自动更新节点用户数据
      this.updateNodeUsers();
    },
    /**
     *  更新节点用户数据
     */
    updateNodeUsers() {
      let node = this.cc.find(item => item.id === this.selectedNode.id);
      if (node) {
        node.users = [...this.nowNodeAuditUser];
      }
      console.log(node, 'nodenodenode');
    },
    /**
     *  查看更多关闭
     */
    popupClose() {
      this.auditPopup = false;
    },
    /**
     *  查看更多
     */
    auditMore(e) {
      this.selectedNode = e
      this.nowNodeAuditUser = e.users;
      this.auditPopup = true;
    },
    /**
     *  构建审核人数据
     */
    buildCc() {
      this.cc.forEach((item, index) => {
        if (this.auditList[item.id]) {
          item.users = this.auditList[item.id];
        }
      })
    },
    // 这个函数用于给父组件手动调用 push以选中的人员信息
    pushUsers(nodeList) {
      // 遍历 cc  流程节点数据   手动push已经选好的人List
      this.cc.forEach(item => {
        if (nodeList[item.id]) {
          // 将nodeList[item.id]追加到item.users中 并去重
          item.users = item.users.concat(nodeList[item.id])
          item.users = item.users.reduce((acc, cur) => {
            let has = acc.some(item => item.id === cur.id)
            return has ? acc : acc.concat(cur)
          }, [])
        }
      })
    },
    /**
     *  添加人
     * @param formValue
     */
    addUser(e) {
      this.selectedNode = e
      this.joinCondition()
      this.$emit('addUser', this.selectedNode)
    },
    handleForm(formValue) {
      let formItem = null
      if (!formValue) {
        return
      }
      if (formValue.dclx) {
        // todo formItem = this.formItemMap.get("ssxm")
        formItem = this.processFormInfo["ssxm"];
        if (!formItem) {
          return
        }
        if (formValue.dclx && formValue.dclx === '公餐') {
          formItem.props.hiddenMode = false
        } else {
          formItem.props.hiddenMode = true
        }
      }
      if (formValue.cgmxb) {
        formItem = this.formItemMap.get("zjg")
        let total = 0
        for (let i = 0; i < formValue.cgmxb.length; i++) {
          let cgmx = formValue.cgmxb[i]
          if (cgmx.cgmxbJg && cgmx.cgmxbSl) {
            total = total + parseFloat(cgmx.cgmxbJg) * parseInt(cgmx.cgmxbSl)
          }
        }
        this.formData.zjg = total

      }

      if (formValue.qjsj && formValue.qjsj.length > 1) {
        //getLeave(formValue.qjsj[0], formValue.qjsj[1], 8.5, 18, false, 12, 13.5, [], 0)
        try {
          let qjlx = formValue.qjlx
          if (!qjlx) {
            qjlx = '事假'
          }
          let timeLen = getLeave(formValue.qjsj[0], formValue.qjsj[1], 8.5, 18, true, 12, 13.5, [], qjlx)//timeLength(formValue.qjsj[0],formValue.qjsj[1],'yyyy-MM-dd HH:mm','days')
          if (!this.formData.qjsc || timeLen < parseFloat(this.formData.qjsc)) {
            this.formData.qjsc = timeLen
          }
        } catch (err) {
          this.$message.error(err)
          this.formData.qjsj[0] = ''
          this.formData.qjsj[1] = ''
        }

      }
      if (formValue.qjsc) {
        if (formValue.qjsc === '0') {
          this.$message.error("时长不能为0")
          this.formData.qjsc = ''
        }
      }

    },
    /**
     *  流程开始
     */
    startProcess() {
      if (this.form && this.form.processTemplates && this.form.processTemplates.process) {
        if (typeof this.form.processTemplates.process === 'string') {
          this.form.processTemplates.process = JSON.parse(this.form.processTemplates.process)
        }
        this.processFormInfo = JSON.parse(this.form.processTemplates.formItems)

        // 流程开始
        this.selfSelect = false
        this.processUsers = {};
        this.allProcessUsers = {};
        this.cc = [];
        this.getProcess(this.form.processTemplates.process, this.activities, this.cc);
        this.cc.push({
          title: "结束",
          name: "END",
          icon: "el-icon-success",
          isEdit: false
        })
      }
      this.joinCondition()
    },
    /**
     *  获取流程
     */
    getProcess(process, data, cc) {
      if (null != process && undefined != process) {
        if ('ROOT' === process.type) {
          //发起人节点
          this.getRootNode(cc, process);
        } else if ('APPROVAL' === process.type) {
          //审批节点
          this.getApprovalNode(cc, process);
        } else if ("CC" === process.type) {
          this.getCcNode(cc, process);
        } else if ("CONDITIONS" === process.type) {
          //判断是否符合条件符合走条件分支,否则继续递归子分支
          if (null != process.branchs && undefined != process.branchs) {
            this.getConditionNode(cc, process);
          }
        } else if ("CONCURRENTS" === process.type) {
          this.getConcurrentNode(cc, process);
        }
        if (null != process.children && undefined != process.children) {
          this.getProcess(process.children, data, cc);
        }
      }
    },
    /**
     *  封装开始节点
     * @param cc
     * @param process
     */
    getRootNode(cc, process) {
      cc.push({
        id: process.id,
        title: process.name,
        name: "发起人",
        icon: "el-icon-user-solid",
        isEdit: false,
        users: [this.loginUser],
      })
    },


    loadCacheUser(node) {
      if (node && node.id) {
        let users = this.nodeCacheUsers[node.id]
        if (users && users.length > 0) {
          node.users = [].concat(users);
          this.processUsers[node.id] = [].concat(users);
        }
      }
    },

    loadCacheAllUser(node) {
      if (node && node.id) {
        let users = this.nodeCacheUsers[node.id]
        if (users && users.length > 0) {
          node.users = [].concat(users);
          this.allProcessUsers[node.id] = [].concat(users);
        }
      }
    },

    getAllProcessUsers() {
      return this.allProcessUsers;
    },

    /**
     *  封装审批节点
     * @param cc
     * @param process
     */
    getApprovalNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "审批人",
        icon: "el-icon-s-check",
        isEdit: false,
        multiple: false,
        mode: process.props.mode,
        users: [],
        desc: "",
      }
      //判断审批人类型
      switch (process.props.assignedType) {
        case "ASSIGN_USER":
          data.users = this.$deepCopy(process.props.assignedUser);
          //data.desc = "指定审批人";

          if (this.processData.changeUser) {
            data.isEdit = true;
            data.multiple = data.users.length > 1 || true;
            data.desc = "请选择办理人";
          }
          this.loadCacheAllUser(data);
          break;
        case "ASSIGN_LEADER":
          //data.desc = "指定部门的领导";
          break;
        case "SELF":
          data.users = [this.loginUser]
          //data.desc = "发起人自己审批";
          this.loadCacheAllUser(data);
          break;
        case "PROJECT_MANAGER":
          //data.users = [this.loginUser]
          if (this.projectLeader && this.projectLeader.projectManagerName) {
            data.users = [{name: this.projectLeader.projectManagerName}]
          } else {
            data.assigneeName = "";
          }
          this.loadCacheAllUser(data);
          break;
        case "SELF_SELECT":
          data.isEdit = true;
          data.multiple = process.props.selfSelect.multiple || false;
          data.desc = "请选择办理人";
          this.selfSelect = true
          if (!process.props.selfSelect.hasOwnProperty('required') || process.props.selfSelect.required) {
            data.required = true
          } else {
            data.required = false
          }
          this.loadCacheUser(data)
          this.loadCacheAllUser(data);
          break;
        case "LEADER_TOP":
          //data.desc = "连续多级主管审批";
          break;
        case "LEADER":
          data.desc =
              1 === process.props.leader.level
                  ? "直接主管审批"
                  : "第".concat(process.props.leader.level, "级主管审批");
          break;
        case "ROLE":
          data.desc = "由角色[".concat(
              (process.props.role || []).map(function (e) {
                return e.name;
              }),
              "]办理"
          );
          break;
        case "REFUSE":
          data.desc = "流程此处将自动驳回";
          break;
      }
      cc.push(data);
    },
    getCcNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        icon: "el-icon-s-promotion",
        name: "抄送人",
        isEdit: process.props.shouldAdd,
        type: "user",
        multiple: true,
        desc: process.props.shouldAdd ? "请选择抄送人" : "",
        users: this.$deepCopy(process.props.assignedUser),
      };
      if (data.isEdit) {
        //this.processUsers[data.id] = [];
      }
      if (data.users && data.users.length > 0) {
        this.processUsers[data.id] = [].concat(data.users);
        this.allProcessUsers[data.id] = [].concat(data.users);
        data.users.forEach((item, index) => {
          item.selected = true;
        })
      }
      this.loadCacheUser(data)
      this.loadCacheAllUser(data);
      cc.push(data);
    },
    getConditionNode(cc, process) {
      for (var r = null, s = 0; s < process.branchs.length; s++) {
        for (var a = process.branchs[s], n = false, o = 0, i = 0; i < a.props.groups.length; i++) {
          if (a.typeElse) {
            r = a;
            break;
          }
          if (((n = this.getConditionResultByGroup(a.props.groups[i])), "OR" === a.props.groupsType && n)) {
            r = a;
            break;
          }
          "AND" === a.props.groupsType && n && o++;
        }
        if (r) {
          break;
        }
        if (o === a.props.groups.length) {
          r = a;
          break;
        }

      }
      var d = []
      r ? this.getProcess(r, d, cc)
          : console.log(
              "条件节点 "
                  .concat(process.id, " => ")
                  .concat(process.name, " 均不满足，无法继续"),
              process
          );
    },
    getConcurrentNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "并行分支",
        icon: "el-icon-s-operation",
        isEdit: false,
        active: process.branchs[0].id,
        options: [],
        desc: "切换分支可显示对应执行流程",
        branchs: {},
      }
      cc.push(data);
      process.branchs.forEach((b) => {
        data.options.push({id: b.id, title: b.name});
        this.$set(data.branchs, b.id, []);
        var d = [];
        this.getProcess(b.children, d, data.branchs[b.id])
      })

    },
    getConditionResultByGroup: function (e) {
      var t = this,
          r = !1,
          s = 0;
      e.conditions.forEach(function (e) {
        return t.conditionFormItem.add(e.id);
      });

      for (var a = 0; a < e.conditions.length; a++) {
        var n = e.conditions[a];
        switch (n.valueType) {
          case "Number":
            // 这是number类型判断
            r = this.numberCompare(n)
            break;
          case "String":
            // 这是string类型判断
            r = this.stringCompare(n)
            break;
          case "Date":
            // 这是data类型判断
            break;
          case "User":
            r = this.userCompare(n)
            // 这是user类型判断
            break;
          case "notInUser":
            r = this.notInUserCompare(n)
            break;
          case "Array":
            // 这是array类型判断
            break;
        }
        if (r && "OR" === e.groupType) break;
        r && "AND" === e.groupType && s++;
      }
      return (
          "AND" === e.groupType && (r = s === e.conditions.length), r
      );
    },
    notInUserCompare: function (e) {
      let currentUserId = JSON.parse(cache.session.get('userInfo')).userId;

      JSON.parse(cache.session.get('userInfo'))

      let users = e.value
      if (!users || users.length === 0) {
        return true;
      }
      let conditionUserIds = []
      let result = false
      for (let i = 0; i < users.length; i++) {
        let userObj = users[i]
        conditionUserIds.push(userObj.id)
      }
      if (!conditionUserIds.includes(currentUserId)) {
        result = true
      }
      return result
    },
    numberCompare: function (e) {
      var t = this.formData[e.id];
      switch (e.compare) {
        case ">":
          return t > parseFloat(e.value[0]);
        case "<":
          return t < parseFloat(e.value[0]);
        case "=":
          return t === parseFloat(e.value[0]);
        case ">=":
          return t >= parseFloat(e.value[0]);
        case "<=":
          return t <= parseFloat(e.value[0]);
        case "B":
          return (
              t > parseFloat(e.value[0]) && t < parseFloat(e.value[1])
          );
        case "AB":
          return (
              t >= parseFloat(e.value[0]) && t < parseFloat(e.value[1])
          );
        case "BA":
          return (
              t > parseFloat(e.value[0]) && t <= parseFloat(e.value[1])
          );
        case "ABA":
          return (
              t >= parseFloat(e.value[0]) && t <= parseFloat(e.value[1])
          );
        case "IN":
          return e.value.indexOf(String(t)) > -1;
        default:
          return !1;
      }
    },
    stringCompare: function (e) {
      // var t = this.formData[e.id];
      // if (t) {
      //   if (t.indexOf(",")) {
      //     t = t.split(",")[0]
      //   }
      // }
      // switch (e.compare) {
      //   case "=":
      //     return e.value[0] === String(t);
      //   case "IN":
      //     return e.value.indexOf(String(t)) > -1;
      //   default:
      //     return !1;
      // }
      var t = this.formData[e.id]
      if (t) {
        if (t.indexOf(',')) {
          t = t.split(',')[0]
        }
      }
      switch (e.compare) {
        case '=':
          return e.value[0] === String(t)
        case 'IN':
          let contains = false
          for (let i = 0; i < e.value.length; i++) {
            if (String(this.formData[e.id]).indexOf(e.value[i]) > -1) {
              contains = true
            }
          }
          return contains
        default:
          return !1
      }
    },
    userCompare: function (e) {
      let currentUserId = JSON.parse(cache.session.get('userInfo')).userId;
      let currentDeptIds = JSON.parse(cache.session.get('userInfo')).deptIds;
      let users = e.value
      if (!users || users.length === 0) {
        return false;
      }
      let result = false
      for (let i = 0; i < users.length; i++) {
        let userObj = users[i]
        if (userObj.type === 'user') {
          if (userObj.id === currentUserId) {
            result = true
            break
          }
        }
        if (userObj.type === 'dept') {
          if (currentDeptIds.includes(userObj.id)) {
            result = true
            break
          }
        }
      }
      return result
    },
    /**
     *  删除用户
     */
    delUser(node, user) {
      let users = node.users
      let userIndex = users.findIndex((t) => {
        return t.id === user.id;
      })
      if (userIndex === -1) {
        return
      }
      this.joinCondition()
      users.splice(userIndex, 1);
      this.processUsers[node.id] = [].concat(node.users);
      this.allProcessUsers[node.id] = [].concat(node.users);
    },
    /**
     *  处理姓名
     * @param name
     * @returns {string|*|string}
     */
    getShortName(name) {
      if (name) {
        return name.length > 2 ? name.substring(0, 1) : name;
      }
      return '**'
    },
  },
}
</script>

<style lang="less" scoped>
.line {
  width: 3px;
  height: 50px;
  margin: 5px 24px
}

.avatar {
  width: 70px;
  height: 70px;
  line-height: 70px;
  border-radius: 50%;
  background: @theme-color;
  text-align: center;
  font-size: 36px;
}

.customAlert {
  padding: 0px;
}

.income-form-tit {
  gap: 10px;
  box-sizing: border-box;
  background-color: #FEFAF2;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.iconSize {
  font-size: 22px;
  padding: 2px;
  color: red;
}
</style>
